import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { requestDTEsAsync, selectData, selectIsLoading } from 'slices/feSlice';
import api from '../../_helpers/api';
import { Panel } from 'rsuite';
import { Filters } from 'Components/Common/Filter/Filters';
import { downloadFile, downloadReport } from 'Components/_helpers/utils';

import SendMailModal from 'Components/Common/SendMail/SendMailModal';
import { CustomTable } from 'Components/Common/Table/CustomTable';
import { CustomPagination, LIMIT } from 'Components/Common/Table/CustomPagination';

export const FETable = () => {
  const documentsData = useSelector(selectData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currFil, setCurrFil] = useState({});

  const [limit, setLimit] = React.useState(LIMIT);
  const [page, setPage] = React.useState(1);
  const [openModalForm, setOpenModalForm] = useState(false);
  const loading = useSelector(selectIsLoading);

  const handleChangePage = (val) => {
    setPage(val);
    dispatch(requestDTEsAsync({ ...currFil, pagination: { NumberPage: val, SizePage: limit } }));
  };

  const handleFilter = (params) => {
    setPage(1);
    setCurrFil(params);
    dispatch(requestDTEsAsync(params));
  };

  const handleDownloadReport = () => {
    downloadReport(
      `${api.getUri()}FE/DTE/Report`,
      `DTE FE Report.xlsx`,
      currFil
    );    
  };

  const handleChangeLimit = (limit) => {
    setPage(1);
    setLimit(limit);
    dispatch(requestDTEsAsync({ pagination: { NumberPage: page, SizePage: limit } }));
  };

  const onSelectAction = (eventKey, rowData) => {
    switch (eventKey) {
      case 1:
        downloadFile(
          `${api.getUri()}FE/Json?codigoGeneracion=${rowData.dte.identificacion.codigoGeneracion}`,
          `${rowData.dte.identificacion.codigoGeneracion}.json`
        );
        break;
      case 2:
        console.log('correo');
        break;
      case 3:
        downloadFile(
          `${api.getUri()}FE/Zip?codigoGeneracion=${rowData.dte.identificacion.codigoGeneracion}`,
          `${rowData.dte.identificacion.codigoGeneracion}.zip`
        );
        break;
      case 4:
        navigate(`/main/fe/${rowData.dte.identificacion.codigoGeneracion}`);
        break;
      case 5:
        setOpenModalForm(true);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    dispatch(requestDTEsAsync({ pagination: { NumberPage: page, SizePage: limit } }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Panel>
      <div className="table__hader">
        <h4>DTE: Factura Electrónica (FE)</h4>
      </div>
      <SendMailModal isOpen={openModalForm} setOpen={setOpenModalForm} data={{}} />
      <Filters
        limit={limit}
        page={page}
        tipoDte={'FE'}
        onFilter={handleFilter}
        onDownloadData={handleDownloadReport}
        recordsTotal={documentsData.recordsTotal}
      />
      <CustomTable data={documentsData.items} loading={loading} onSelectAction={onSelectAction} />
      <CustomPagination
        totalRecords={documentsData.recordsTotal}
        limit={limit}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeLimit={handleChangeLimit}
      />
    </Panel>
  );
};
